/** "Not in this workspace, or outside your engagement" - one component, one sentence (Q-03).
 *
 * An engaged Auditor who opens a link outside what they are engaged for was told the product had
 * failed: the receipt drawer said *rule 3, please report it*, the review said *nothing to review*, the
 * import said *this file cannot be read*, the filing said *this workspace does not have it*. Only the
 * record page had the right sentence, and this is that sentence, said once, for all of them.
 *
 * **It confirms nothing.** The sentence is true whether the thing exists or not, because since the S1
 * fix the server answers the two cases identically and a screen that said more would reopen the
 * oracle. What it adds is the way on: the Engagement page states what the engagement covers.
 *
 * Somebody whose reads are not narrowed is told only that there is no such thing here, and is not
 * pointed at an engagement they do not have.
 */

import { Link } from "@tanstack/react-router";

import { useMe } from "../api/auth";
import { isEngaged, outsideEngagementSentence } from "../lib/engagement";
import { keepSearch } from "../screens/search";
import styles from "./OutsideEngagement.module.css";

export function OutsideEngagement({
  noun,
  testId = "outside-engagement",
}: {
  /** What was asked for, in a word or two: "record", "figure", "document", "file". */
  noun: string;
  testId?: string;
}) {
  const { data: me } = useMe();
  const engaged = isEngaged(me);
  return (
    <p className={styles.note} role="note" data-testid={testId}>
      {engaged ? outsideEngagementSentence(noun) : `There is no such ${noun} in this workspace.`}
      {engaged ? (
        <>
          {" "}
          <Link to="/engagement" search={keepSearch} className={styles.link}>
            What your engagement covers
          </Link>
        </>
      ) : null}
    </p>
  );
}
